import React, { memo } from 'react';
import type { JSX } from 'react';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Heading = ({ className = '', value, text, title, children }: Props) => {
  let Tag: keyof JSX.IntrinsicElements;
  let cssClassName = className;

  switch (value) {
    case 1:
      Tag = 'h1';
      cssClassName += ` text-2xl`;
      break;
    case 2:
      Tag = 'h2';
      cssClassName += ' text-xl';
      break;
    case 3:
      Tag = 'h3';
      cssClassName += ' text-lg';
      break;
    case 4:
      Tag = 'h4';
      cssClassName += ' text-base';
      break;
    case 5:
      Tag = 'h5';
      cssClassName += ' text-sm';
      break;
    case 6:
      Tag = 'h6';
      cssClassName += ' text-xs';
      break;
    default:
      Tag = 'h1';
      cssClassName += ' text-2xl';
      break;
  }

  return (
    <Tag className={`${cssClassName} font-bold`} title={title}>
      {text} {children}
    </Tag>
  );
};

export default memo(Heading);
